export default "__VITE_ASSET__lye66h6K__"